import { createContext } from 'react';

import { WidgetAnimationContextType } from '@/features/Dashboard/context/WidgetAnimation/types';

export const WidgetAnimationContext = createContext<WidgetAnimationContextType | null>(null);
